import { call, put } from "redux-saga/effects";

export const REFRESH_DELAY = 500; // ms

/**
 * Fetch data from the server, dispatching a success action on http.ok or
 * a failed action on error.
 * If additional paginated data exists on server, fetch recursively.
 * @param {function} getFn api get function
 * @param {function} success action creator
 * @param {function} failed action creator
 * @param {int} page to fetch
 */
export const fetchPagedSagaFactory = (getFn, success, failed, page = 1) =>
  function* saga() {
    try {
      const nextPage = !this ? page : this.page;
      const { response, links } = yield call(getFn, nextPage);
      yield put(success(response));
      if (links && "next" in links) {
        yield call([{ page: links.next.page }, saga]);
      }
    } catch (error) {
      yield put(failed(error));
    }
  };
